import React from 'react';
import { connect } from 'react-redux';
import { CssBaseline, Box, Grid } from '@mui/material';
import PromoBanner from 'components/PromoBanner';
import LogoBanner from 'components/LogoBanner';
import InfoBanner from 'components/InfoBanner';
import Header from 'components/Header';
import Footer from 'components/Footer';
import { Switch, Route } from 'react-router-dom';
import FlashMessage from './FlashMessage';
import MediaQuery from 'react-responsive';
import { push } from 'connected-react-router';
import { Helmet } from 'react-helmet';
import { appendSeoBrand } from 'utils/seo';
import { changeLocale } from "../actions/SiteActions";

export class MainLayout extends React.Component {
  renderSiteBanners(site) {
    return(
      <React.Fragment>
        {site.banner_desktop &&
          <MediaQuery minWidth={948}>
            <div className="banner-image" style={{'backgroundImage': 'url(' + site.banner_desktop + ')', height: '300px'}}></div>
          </MediaQuery>
        }
        {site.banner_mobile &&
          <MediaQuery maxWidth={948}>
            <div className="banner-image" style={{'backgroundImage': 'url(' + site.banner_mobile + ')', height: '450px'}}></div>
          </MediaQuery>
        }
      </React.Fragment>
    )
  }

  render() {
    const { site, cart, collection, children, navigateTo, locale, changeLocale } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>{appendSeoBrand(site.page_title)}</title>
          <meta name="robots" content={window.APP_ENV === 'production' ? 'index' : 'noindex'} />
          <meta name="description" content={site.page_title}/>
          <link rel="canonical" href={window.location.href} />
        </Helmet>
        <CssBaseline />
        <Header site={site} cart={cart} locale={locale} changeLocale={changeLocale} navigateTo={navigateTo} />
        {site.header_image &&
          <Grid size={{xs: 12}} align="center">
            <img src={site.header_image} style={{height: '4em', marginTop: '1em'}} alt={site.page_title} />
          </Grid>
        }
        <LogoBanner />
        <Switch>
          <Route path="/" exact component={() => site.promo_banners.length > 0 ? <PromoBanner banners={site.promo_banners} /> : this.renderSiteBanners(site)} />
          {collection &&
            <Route path="/collections/:categorySlug" exact component={() => collection.promo_banners.length > 0 ? <PromoBanner banners={collection.promo_banners} /> : <img src={collection.banner_image} className="full-width" /> } />
          }
          <Route component={() => this.renderSiteBanners(site)} />
        </Switch>
        <Switch>
          <Route path="/" exact component={() => <InfoBanner features={site.features} />} />
        </Switch>
        <Box className="main-layout-container"
          sx={{
            '& *:not(button, button span, .checkout-step svg, .checkout-step circle, .input-error, .thanks-tick, .thanks-tick path, .rccs__card--front, .rccs__card--front div, .rccs__cvc, .adyen-checkout__input)': {
              color: window.BODY_FONT_COLOUR
            }
          }}
        >
          <div className="alert-flash"><FlashMessage /></div>
          {children}
        </Box>
        <Footer site={site} />
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    site: state.site.site,
    cart: state.cart.cart,
    collection: state.collection.collection,
    locale: state.locale.locale
  };
}

const mapDispatchToProps = {
  navigateTo: (path) => push(path),
  changeLocale: (locale) => changeLocale(locale)
}

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
